import { Box, styled } from '@mui/material';
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';
import { ExtendedEmploymentDayViolationResponse } from './DayLimitViolations.types';

export const StyledTableCRUDLayout = styled(
  TableCRUDLayout<ExtendedEmploymentDayViolationResponse>
)(({ theme }) => ({
  marginTop: theme.spacing(1),
  // Hide the checkbox if the row/input is disabled
  '.MuiCheckbox-root input[type="checkbox"]:disabled + *': {
    display: 'none'
  }
}));

export const IconBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: theme.spacing(1),
  marginLeft: theme.spacing(0.5),
  fontSize: '16px'
}));
